import styled from '@emotion/styled';
import { Flex } from '@lightspeed/flame/Core';
import { IconArrowLeft } from '@lightspeed/flame/Icon/ArrowLeft';
import { IconArrowRight } from '@lightspeed/flame/Icon/ArrowRight';
import { IconDelete, IconDeleteProps } from '@lightspeed/flame/Icon/Delete';
import { Text } from '@lightspeed/flame/Text';
import { Tooltip } from '@lightspeed/flame/Tooltip';

export const StyledFlex = styled(Flex)`
  .diff-row:nth-of-type(odd) {
    background-color: #f8f8f8;
  }
  .diff-row:nth-of-type(even) {
    background-color: #fff;
  }
  .header {
    background-color: #ddd;
  }
`;

export const StyledDeleteIcon = styled(IconDelete)<IconDeleteProps>`
  cursor: pointer;
`;

export const StyledSpan = styled.span`
  &:hover {
    .cr-icon {
      fill: #ae0000;
    }
  }
`;

export const StyledArrowLeft = styled(IconArrowLeft)`
  cursor: pointer;
`;

export const StyledArrowRight = styled(IconArrowRight)`
  cursor: pointer;
`;

export const StrikeThroughText = styled(Text)`
  text-decoration: line-through;
`;

export const StyledTooltip = styled(Tooltip)`
  width: 240px;
`;
